import { Box } from "@mui/material"

const validateData = (data, finance) => {

    const response = []

    if (!data?.name?.length > 0)
        response.push(<Box>Digite o nome do serviço.</Box>)
    if (!data?.payment_method?.length > 0)
        response.push(<Box>Selecione o método</Box>)

    if (finance && !data.cashaccount)
        response.push(<Box>Selecione a conta caixa</Box>)

    if (response.length === 0)
        return ''

    return (response)
}

export default validateData